import { render } from "./wfm-sidebarTabs.vue?vue&type=template&id=4ee11644&scoped=true"
import script from "./wfm-sidebarTabs.vue?vue&type=script&lang=js"
export * from "./wfm-sidebarTabs.vue?vue&type=script&lang=js"

import "./wfm-sidebarTabs.vue?vue&type=style&index=0&id=4ee11644&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ee11644"]])

export default __exports__